module.exports = __webpack_public_path__ + "static/media/darkChocolate.100350b4.png";